import {all, call, fork, put, takeEvery, takeLatest} from 'bukku/shared/SagaService';
import actions from './actions';
import {get, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, successSagaFn} from "../helper";

const successKeys = [
    actions.NOTIFICATION_READ_SUCCESS,
];
const errorKeys = [
    actions.NOTIFICATION_READ_ERROR,
];

const getSuccessMsg = () => null;

function* setAsReadNotificationRequest() {
    yield takeLatest(actions.NOTIFICATION_SET_AS_READ_REQUEST, function* (payload, context) {
        try {
            yield call(puto, '/notifications', null, context);
            yield put(
                actions.onReadNotification(),
            );
        }
        catch (e) {
            yield put({
                type: actions.NOTIFICATION_SET_AS_READ_ERROR,
            });
        }
        finally {
            // nothing
        }
    });
}

// Create location
function* readNotificationRequest() {
    yield takeEvery(actions.NOTIFICATION_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ last_id }) {
                const response = yield call(get, '/notifications', {page_size: 50, last_id}, context);
                const data = yield response.data;
                yield put({
                    type: actions.NOTIFICATION_READ_SUCCESS,
                    paging: data.paging,
                    notifications: data.notifications,
                    is_last: data.is_last,
                    unreadCount: data.unread_count,
                });
            },
            false);
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readNotificationRequest),
        fork(setAsReadNotificationRequest),
    ]);
}
